import { Tag } from "antd"
import { useNavigate } from "react-router-dom"
import { Navigation } from "../../../api/constants"
import BaseTableRow from "../../../components/layout/BaseTableRow"
import { P } from "../../../auth/permissions"
import { Authorized } from "../../../components/authentication/Authorized"
import { countTourWeekTasks } from "../data/tourTasks"
import { Tour, TourObjectTask } from "../types"
import TourDeletePopover from "./TourDeletePopover"
import TourWeekdayStrip from "./TourWeekdayStrip"

type TourTableRowType = {
    tour: Tour
    tasksByObject: Map<string, TourObjectTask[]>
    deleteTour: (id: string) => void
}

export default function TourTableRow(props: TourTableRowType) {
    const navigate = useNavigate()
    const employeeName = props.tour.employee ? `${props.tour.employee.first_name} ${props.tour.employee.last_name}` : "Nicht zugewiesen"
    const { open, done } = countTourWeekTasks(props.tour, props.tasksByObject)

    return (
        <BaseTableRow onClick={() => navigate(Navigation.TOURS + props.tour._id)}>
            <td className="table-cell">
                <p className="line-clamp-1 text-center font-medium">{props.tour.name}</p>
            </td>
            <td className="table-cell">
                <p className="line-clamp-1 text-center min-w-[10rem]">{employeeName}</p>
            </td>
            <td className="table-cell">
                <p className="line-clamp-1 text-center">{props.tour.stops.length}</p>
            </td>
            <td className="table-cell">
                <p className="flex justify-center gap-1 flex-wrap" title="Aufgaben dieser Woche an den Objekten der Tour">
                    <Tag className="m-0 min-w-[4.5rem] text-center" color="gold">
                        {open} offen
                    </Tag>
                    <Tag className="m-0 min-w-[4.5rem] text-center" color={done > 0 ? "green" : "default"}>
                        {done} erledigt
                    </Tag>
                </p>
            </td>
            <td className="hidden lg:table-cell">
                <div className="flex justify-center py-1">
                    <TourWeekdayStrip tour={props.tour} compact />
                </div>
            </td>
            <td className="table-cell">
                <p className="line-clamp-1 text-center">
                    <Tag className="w-24 text-center" color={props.tour.active ? "green" : "default"}>
                        {props.tour.active ? "Aktiv" : "Pausiert"}
                    </Tag>
                </p>
            </td>
            <td onClick={(event) => event.stopPropagation()}>
                <Authorized allOf={[P.termine_management]}>
                    <TourDeletePopover
                        text="Wollen Sie diese Tour wirklich entfernen?"
                        onConfirm={() => props.deleteTour(props.tour._id)}
                        iconClassName="w-6 h-6 cursor-pointer hover:text-error mx-auto"
                    />
                </Authorized>
            </td>
        </BaseTableRow>
    )
}
